<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container p-0 m-0  mx-auto order-print-route" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.sarayeghalam.com\/storage\/icons\/9Lr1Vq89UNhqLq3ueQ6XUhJUoI20GirP3ApNVkhP.png","alt":"sarayeghalam"},...{}}' :style='"width:150px"' class="" ></m-img></template>
                </m-div><m-factor-header-1 v-bind='{...{},...{}}' :style='""' class="" ></m-factor-header-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mFactorHeader1 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/FactorHeader/FactorHeader1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mFactorHeader1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
